import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbBtnWhiteDirective } from 'rev-shared/ui/buttons/VbBtnWhite.Directive';

import { VbUiColorSelectorComponent } from './VbUiColorSelector.Component';

const declarations = [
	VbUiColorSelectorComponent
];

@NgModule({
	declarations,
	exports: declarations,
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		ValidationAngularModule,
		ValidationModule,
		VbBtnWhiteDirective
	]
})
export class VbUiColorSelectorModule {}
